import { __ } from '@wordpress/i18n';
import { PanelBody, SelectControl, RangeControl } from "@wordpress/components";
import { alignBtnOpt, paginationTypeOpt } from '../../../../utils/options';
import { BControlPro } from '../../../../../../bpl-tools/ProControls';

const GridGeneral = ({ attributes, updateObject, multipleAttrChange, premiumProps }) => {
    const { grid, postsQuery, sourceType } = attributes;
    const { paginationType, loadMoreBtn } = grid;
    const { per_page } = postsQuery;
    const { align } = loadMoreBtn;

    return <>
        <PanelBody className='' title={__('Pagination', 'slider')} initialOpen={false}>

            {(sourceType !== 'posts' && sourceType !== 'woo') && <BControlPro label={__('Per Page', 'slider')} labelPosition='side' className='mt10' value={per_page} onChange={val => updateObject('postsQuery', 'per_page', val)} min={1} Component={RangeControl}  {...premiumProps} />}

            <BControlPro label={__('Pagination Type', 'slider')} className='mt10' options={paginationTypeOpt} value={paginationType} onChange={val => updateObject('grid', 'paginationType', val)} Component={SelectControl} {...premiumProps} />

            <BControlPro label={__('Position', 'slider')} className='mt10' options={alignBtnOpt} value={align} onChange={val => multipleAttrChange('grid', 'loadMoreBtn', "align", val)} Component={SelectControl} {...premiumProps} />
        </PanelBody>
    </>
}
export default GridGeneral;